function Email() {
  return (
    <>
      <h2>Getting Email</h2>
      <ul>
        <li>Server Type: IMAP</li>
        <li>Incoming Server: omnomnm.com</li>
        <li>Port: 993</li>
        <li>Security: SSL/TLS</li>
        <li>Authentication: Password</li>
      </ul>

      <h2>Sending Email</h2>
      <ul>
        <li>Server Type: SMTP</li>
        <li>Outgoing Server: omnomnm.com</li>
        <li>Port: 465</li>
        <li>Security: SSL/TLS</li>
        <li>Authentication: Password</li>
      </ul>
    </>
  );
};

export default Email;
